<template>
  <div class="contentBox min-w-1400">
    <div class="flexBox min-w-1400">
      <div class="max-w-1400">
        <div class="textContent">
          <div class="title">นโยบายความเป็นส่วนตัว</div>
          <div class="textBox" style="white-space: pre-wrap" v-html="text"></div>
      </div>
      </div>
    </div>
  </div>

</template>

<script>
import "./index.css";

export default {
  data(){
    return{
      text:`
นโยบายความเป็นส่วนตัว (Privacy Policy)
ชื่อผลิตภัณฑ์: Rocket เงินกู้
ชื่อบริษัท: SRISOMBOON BUSINESS CENTER COMPANY LIMITED
ที่อยู่: 4-10 Phra Ram Road, Tha Hin Subdistrict, Mueang District, Lop Buri Province 15000
อีเมล: service@srisomboonbusiness.com
วันที่มีผลบังคับใช้: ปี 2025
เรามีความเคารพและให้ความสำคัญต่อความเป็นส่วนตัวของคุณ นโยบายความเป็นส่วนตัวนี้จัดทำขึ้นเพื่ออธิบายว่าเมื่อคุณใช้งานแอป Rocket เงินกู้ เราจะเก็บรวบรวม ใช้ เปิดเผย และปกป้องข้อมูลส่วนบุคคลของคุณอย่างไร นโยบายนี้สอดคล้องกับพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคลของประเทศไทย (PDPA) และนโยบายข้อมูลของผู้ใช้ตามมาตรฐาน Google Play

1. ข้อมูลที่เราเก็บรวบรวม
เราจะเก็บข้อมูลเฉพาะที่จำเป็นต่อการให้บริการสินเชื่อเท่านั้น และจะเปิดใช้สิทธิ์ต่าง ๆ ก็ต่อเมื่อคุณอนุญาต
1.1 ข้อมูลบัญชีและข้อมูลยืนยันตัวตน
- หมายเลขโทรศัพท์มือถือ
- ชื่อ–นามสกุล และหมายเลขบัตรประชาชน
- ข้อมูลที่ใช้ในการลงทะเบียน
- รูปถ่ายบัตรประชาชน, รูปเซลฟี, วิดีโอตรวจจับการมีตัวตน (KYC)
1.2 ข้อมูลอุปกรณ์ (เพื่อความปลอดภัยและตรวจจับการทุจริต)
- Android ID และรุ่นอุปกรณ์
- เวอร์ชันของระบบปฏิบัติการ
- สถานะเครือข่ายและที่อยู่ IP
- ความปลอดภัยของระบบ (เช่น การรูทเครื่อง หรือการใช้งานบนอีมูเลเตอร์)
1.3 สิทธิ์ที่มีความอ่อนไหวและวัตถุประสงค์ (เป็นไปตามนโยบาย Google Play)
(1) สิทธิ์เข้าถึง SMS
ใช้เฉพาะสำหรับ: ข้อความจากธนาคาร ข้อความการชำระเงิน ใบแจ้งยอด และข้อความธุรกรรมทางการเงิน
วัตถุประสงค์:
- ยืนยันการโอนเงินเข้าบัญชี
- แจ้งเตือนการชำระเงิน
- วิเคราะห์ความเสี่ยงและป้องกันการทุจริต
- ใช้ในกระบวนการอนุมัติเงินกู้โดยอัตโนมัติ
จะไม่อ่าน SMS ส่วนตัวหรือแชทส่วนบุคคล
(2) สิทธิ์เข้าถึงรูปภาพ / ไฟล์ / สื่อ
วัตถุประสงค์:
- อัปโหลดรูปบัตรประชาชน
- อัปโหลดเอกสารแสดงรายได้หรือเอกสารอื่น ๆ
- ใช้ในการยืนยันตัวตน (KYC)
จะไม่สแกนหรืออัปโหลดรูปภาพอื่น ๆ ในอุปกรณ์ของคุณ
(3) สิทธิ์เข้าถึงตำแหน่งแบบประมาณการ (Approximate Location)
วัตถุประสงค์:
- ตรวจจับความเสี่ยง (ป้องกันการหลอกลวงข้ามพื้นที่)
- ยืนยันความถูกต้องของตัวตน
- ใช้ในโมเดลคะแนนความเสี่ยง
จะไม่เก็บตำแหน่งแบบแม่นยำ และจะไม่ติดตามตำแหน่งแบบต่อเนื่อง
(4) สิทธิ์ดูรายชื่อแอปที่ติดตั้ง (App List / Installed Apps)
วัตถุประสงค์:
- วิเคราะห์ความเสี่ยง (ตรวจสอบแอปสินเชื่อที่มีความเสี่ยงสูง)
- ป้องกันการโกง เช่น เครื่องจำลอง (Emulator) หรือเครื่องมือแก้ไขระบบ
- ป้องกันพฤติกรรมก่อหนี้หรือทุจริต
จะอ่านเฉพาะชื่อแพ็กเกจของแอป ไม่อ่านข้อมูลภายในแอป
(5) ข้อความธุรกรรมการเงิน (Financial SMS)
วัตถุประสงค์:
- ยืนยันการโอนเงินและการชำระหนี้
- สร้างคะแนนความเสี่ยง
- ป้องกันการฉ้อโกง
จะอ่านเฉพาะข้อความทางการเงิน ไม่อ่านข้อความส่วนตัวอื่น
(6) สิทธิ์เข้าถึงปฏิทิน (Calendar Permission)
วัตถุประสงค์:
- สร้างกิจกรรมเตือนวันครบกำหนดชำระเงินโดยอัตโนมัติ
- ป้องกันการล่าช้าหรือค้างชำระ
- จะไม่อ่านเหตุการณ์ที่มีอยู่ในปฏิทิน
- จะไม่อัปโหลดข้อมูลจากปฏิทิน
สร้างเฉพาะกิจกรรมที่เกี่ยวข้องกับ Rocket เงินกู้ เท่านั้น
1.4 ข้อมูลเกี่ยวกับรายการสินเชื่อ
- ข้อมูลที่ใช้สมัครสินเชื่อ
- ผลการตรวจสอบ
- วงเงินและสถานะการโอนเงิน
- ประวัติการชำระเงิน

2. วิธีที่เราใช้ข้อมูลของคุณ
เราใช้ข้อมูลของคุณเพื่อวัตถุประสงค์ที่ถูกต้องตามกฎหมาย ได้แก่:
- สมัคร ตรวจสอบ อนุมัติ และปล่อยสินเชื่อ
- ยืนยันตัวตน (KYC)
- ประเมินความเสี่ยงและป้องกันการฉ้อโกง
- ใช้ในระบบอนุมัติเงินกู้อัตโนมัติ
- สร้างการแจ้งเตือนในปฏิทิน
- ให้บริการช่วยเหลือลูกค้า
- ปฏิบัติตามข้อกำหนดทางกฎหมายและกฎระเบียบ
- เพิ่มคุณภาพและเสถียรภาพของบริการ
เราไม่ขายข้อมูลของคุณ และไม่ใช้เพื่อโฆษณาที่ไม่ได้รับอนุญาต

3. การเปิดเผยข้อมูล
เราจะเปิดเผยข้อมูลเฉพาะในกรณีที่จำเป็นตามกฎหมายหรือเพื่อให้บริการเท่านั้น
3.1 พันธมิตรหรือผู้ให้บริการ (ใช้ข้อมูลเท่าที่จำเป็น)
- ธนาคารและผู้ให้บริการการชำระเงิน
- หน่วยงานตรวจสอบตัวตน (KYC)
- ผู้ให้บริการด้านความปลอดภัยหรือการประเมินความเสี่ยง
- ผู้ให้บริการคลาวด์และเซิร์ฟเวอร์
พันธมิตรทุกรายต้องทำข้อตกลงคุ้มครองข้อมูล (DPA)
3.2 การเปิดเผยตามกฎหมาย
หากศาล หน่วยงานรัฐ หรือหน่วยงานกำกับดูแลร้องขออย่างถูกต้องตามกฎหมาย เราอาจเปิดเผยข้อมูลตามจำเป็น

4. การเก็บรักษาและความปลอดภัยของข้อมูล
เราใช้มาตรการด้านความปลอดภัยระดับองค์กร เพื่อป้องกันไม่ให้ข้อมูลของคุณถูกเข้าถึง นำไปใช้ หรือเปิดเผยโดยไม่ได้รับอนุญาต
4.1 ระยะเวลาการเก็บข้อมูล
(1) ตามความจำเป็นของธุรกิจ
- เก็บข้อมูลตลอดระยะเวลาที่คุณใช้บริการ
- หลังจากปิดบัญชีสินเชื่อ จะเก็บข้อมูลตามที่กฎหมายกำหนด (ปกติ 1–3ปี)
(2) ตามข้อกำหนดทางกฎหมาย
ตัวอย่างเช่น:
- บันทึกธุรกรรม
- ข้อมูลยืนยันตัวตน
- ข้อมูลที่เกี่ยวข้องกับกฎหมายป้องกันการฟอกเงิน (AML)
(3) เมื่อหมดระยะเวลาการเก็บรักษา
ข้อมูลจะถูก:
- ลบอย่างปลอดภัย หรือ
- ทำให้ไม่สามารถระบุตัวตนได้ (Anonymization)

4.2 มาตรการรักษาความปลอดภัยของข้อมูล
(1) การเข้ารหัสข้อมูล
- ใช้มาตรฐาน SSL/TLS ในระหว่างการส่งข้อมูล
- เก็บข้อมูลในรูปแบบเข้ารหัส เช่น AES
- ทำการปกปิดข้อมูลสำคัญ (Data Masking)
(2) การควบคุมการเข้าถึง
- แบ่งสิทธิ์การเข้าถึงตามความจำเป็น
- บันทึกและตรวจสอบประวัติการเข้าถึง
- อนุญาตเฉพาะเจ้าหน้าที่ที่ได้รับสิทธิ์เท่านั้น
(3) ระบบป้องกันความปลอดภัย
- Firewall / IDS / Antivirus
- ระบบตรวจจับการโกงและตรวจสอบอุปกรณ์
- อัลกอริทึมประเมินความเสี่ยงหลายชั้น
(4) การสำรองข้อมูลและการกู้คืนระบบ
- สำรองข้อมูลเป็นประจำ
- เก็บข้อมูลแบบ Redundant หลายศูนย์
- ระบบกู้คืนฉุกเฉินเพื่อความต่อเนื่องของบริการ
(5) การตรวจสอบจากบุคคลภายนอก
- การทดสอบเจาะระบบ (Penetration Test)
- การตรวจสอบด้านความปลอดภัยของผู้ให้บริการภายนอก
(6) การจัดการภายใน
- การฝึกอบรมเจ้าหน้าที่ด้านความเป็นส่วนตัว
- สัญญารักษาความลับ
- ตรวจสอบกระบวนการและสิทธิ์เข้าถึงเป็นประจำ

5. สิทธิของผู้ใช้งาน
เราให้ความสำคัญกับสิทธิของคุณตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคลของประเทศไทย (PDPA) และให้คุณสามารถควบคุมข้อมูลของคุณได้อย่างเต็มที่ คุณสามารถยื่นคำร้องเกี่ยวกับข้อมูลส่วนบุคคลได้ตลอดเวลา ผ่านช่องทางบริการลูกค้าภายในแอป อีเมล หรือแบบฟอร์มออนไลน์ และเราจะดำเนินการภายในระยะเวลาที่สมเหตุสมผล
5.1 สิทธิในการเข้าถึงข้อมูล (Right of Access)
คุณมีสิทธิร้องขอให้เราเปิดเผยข้อมูลต่อไปนี้:
- ข้อมูลส่วนบุคคลทั้งหมดที่เราเก็บรักษา
- แหล่งที่มาของข้อมูล
- วัตถุประสงค์ในการประมวลผล
- ผู้ที่เราเปิดเผยหรือแบ่งปันข้อมูลให้
- ระยะเวลาการจัดเก็บ
- วิธีการที่เราใช้ในการจัดเก็บและรักษาความปลอดภัยของข้อมูล
คุณสามารถขอสำเนาข้อมูลในรูปแบบที่สามารถอ่านได้หรือดาวน์โหลดได้
5.2 สิทธิในการแก้ไขข้อมูล (Right to Rectification)
หากข้อมูลของคุณไม่ถูกต้อง ไม่สมบูรณ์ หรือไม่เป็นปัจจุบัน คุณมีสิทธิขอให้เราแก้ไขหรือปรับปรุงให้ถูกต้อง เช่น หมายเลขโทรศัพท์ ที่อยู่ อาชีพข้อมูลติดต่อและข้อมูลประจำตัวอื่นๆ
5.3 สิทธิในการลบข้อมูล (Right to Erasure / Right to Be Forgotten)
คุณสามารถขอให้เราลบข้อมูลของคุณในกรณีดังต่อไปนี้:
- ไม่มีความจำเป็นต้องเก็บข้อมูลอีกต่อไป
- คุณถอนความยินยอม
- ข้อมูลถูกประมวลผลโดยผิดกฎหมาย
- คุณเลิกใช้งานบริการของเรา
- เรามีการใช้ข้อมูลไม่เป็นไปตามกฎหมาย
หมายเหตุ:
 ข้อมูลบางประเภท เช่น ข้อมูลสินเชื่อ หลักฐานธุรกรรม หรือเอกสารด้านการเงิน ต้องเก็บรักษาตามกฎหมาย และไม่สามารถลบทันทีได้
5.4 สิทธิในการถอนความยินยอม (Right to Withdraw Consent)
คุณสามารถถอนความยินยอมได้ตลอดเวลา รวมถึง:
- สิทธิ์เข้าถึงรูปภาพ (Gallery)
- สิทธิ์ปฏิทิน (Calendar)
- สิทธิ์ตำแหน่งโดยประมาณ
- สิทธิ์อ่าน SMS ทางการเงิน
- รายการแอปในเครื่อง (App List)
- ข้อมูลที่ต้องได้รับความยินยอมเป็นพิเศษ
หลังถอนความยินยอม เราจะหยุดประมวลผลข้อมูลนั้นทันที แต่บางฟีเจอร์อาจใช้งานไม่ได้ เช่น
- ระบบตรวจสอบอัตโนมัติ
- การประเมินสินเชื่อ
- การป้องกันความเสี่ยงและการฉ้อโกง
- การยืนยันตัวตน
5.5 สิทธิในการร้องเรียน (Right to Lodge a Complaint)
หากคุณเชื่อว่าเราประมวลผลข้อมูลผิดกฎหมาย คุณมีสิทธิร้องเรียนต่อ:
- เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (DPO) ของบริษัท
- คณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (PDPC) ประเทศไทย
เราจะให้ความร่วมมืออย่างเต็มที่ในการตรวจสอบ
5.6 สิทธิในการยกเลิกบัญชี (Right to Delete/Terminate Account)
คุณสามารถร้องขอให้ปิดหรือยกเลิกบัญชี Rocket เงินกู้ ได้ตลอดเวลา โดยผลลัพธ์คือ:
- ข้อมูลที่สามารถลบได้จะถูกลบทันที
- ข้อมูลที่กฎหมายกำหนดต้องเก็บจะถูกเก็บจนกว่าจะครบกำหนดเวลา
- บัญชีของคุณจะไม่สามารถกู้คืนได้หลังจากลบแล้ว

6. การคุ้มครองผู้เยาว์
เราไม่ให้บริการแก่ผู้ใช้อายุต่ำกว่า 20 ปี หากพบการลงทะเบียนของผู้เยาว์ เราจะลบข้อมูลทั

7. การอัปเดตนโยบายความเป็นส่วนตัว
หากมีการเปลี่ยนแปลงนโยบาย เราจะประกาศแจ้งภายในแอป และอาจขอความยินยอมใหม่ในกรณีที่จำเป็น

8.ติดต่อเรา
หากคุณต้องการสอบถาม แก้ไข หรือลบข้อมูลส่วนบุคคล สามารถติดต่อได้ที่:
SRISOMBOON BUSINESS CENTER COMPANY LIMITED
 อีเมล: advise@srisomboonbusiness.com
 ที่อยู่: 4-10 Phra Ram Road, Tha Hin Subdistrict, Mueang District, Lop Buri Province 15000 `
    }
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
};
</script>

<style scoped>
.textContent{
  padding: 50px 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.title{
  color: #333333;
  font-family: "Thonburi";
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 40px;
}
.contentBox {
  display: flex;
  flex-direction: column;
  background-color: #FDFFFF;
  margin-bottom: 50px;
}
.flexBox {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}
.textBox {
  font-size: 18px;
  color: #333333;
}

</style>
